import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx } from "vue"
import _imports_0 from '@/assets/red160px.png'


const _hoisted_1 = { class: "home" }
const _hoisted_2 = { class: "justify-center items-center font-pt-root" }
const _hoisted_3 = { class: "w-full h-full" }
const _hoisted_4 = { class: "ml-0" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = {
  key: 1,
  class: "sm:flex"
}
const _hoisted_7 = ["href"]
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "text-red-600 font-bold" }
const _hoisted_10 = { class: "text-left font-londrina text-4xl" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_12 = { class: "text-left font-bold" }
const _hoisted_13 = { class: "text-left font-bold mt-4" }
const _hoisted_14 = { class: "font-bold text-slate-500" }
const _hoisted_15 = { class: "text-left" }
const _hoisted_16 = { class: "font-bold text-xl" }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", { class: "text-red-600 font-bold" }, [
  /*#__PURE__*/_createTextVNode(" You are buying.... "),
  /*#__PURE__*/_createElementVNode("div", { className: "flex justify-center p-4" }, [
    /*#__PURE__*/_createElementVNode("img", {
      class: "animate-spin h-4 w-8",
      src: _imports_0
    })
  ])
], -1)
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = { key: 2 }
const _hoisted_21 = {
  key: 1,
  class: "bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded mt-6"
}
const _hoisted_22 = /*#__PURE__*/_createElementVNode("a", {
  href: "https://metamask.io/",
  target: "_blank"
}, " Get the MetaMask to get the NFT ", -1)
const _hoisted_23 = [
  _hoisted_22
]
const _hoisted_24 = { key: 2 }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { class: "pt-6 font-londrina text-4xl" }, [
  /*#__PURE__*/_createTextVNode(" minting new one.... "),
  /*#__PURE__*/_createElementVNode("div", { className: "flex justify-center" }, [
    /*#__PURE__*/_createElementVNode("div", { className: "flex justify-center p-4" }, [
      /*#__PURE__*/_createElementVNode("img", {
        class: "animate-spin h-4 w-8",
        src: _imports_0
      })
    ])
  ])
], -1)
const _hoisted_26 = [
  _hoisted_25
]
const _hoisted_27 = { class: "font-londrina text-4xl mt-6" }
const _hoisted_28 = { class: "text-left ml-6" }
const _hoisted_29 = { class: "mt-4" }
const _hoisted_30 = {
  key: 0,
  class: "flex"
}
const _hoisted_31 = { class: "flex-1" }
const _hoisted_32 = ["src"]
const _hoisted_33 = { class: "flex-1" }
const _hoisted_34 = {
  key: 0,
  class: "text-red-600 font-bold"
}
const _hoisted_35 = { class: "text-left font-londrina text-4xl" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_37 = { class: "text-left font-bold" }
const _hoisted_38 = { class: "text-left font-bold text-slate-500 mt-2" }
const _hoisted_39 = { class: "text-left font-bold text-xl" }
const _hoisted_40 = ["href"]
const _hoisted_41 = {
  key: 0,
  class: "text-red-600 font-bold"
}
const _hoisted_42 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_43 = { key: 1 }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_45 = {
  key: 0,
  class: "text-left font-bold text-slate-500 mt-2"
}
const _hoisted_46 = {
  key: 1,
  class: "text-left"
}
const _hoisted_47 = { class: "font-bold text-xl" }
const _hoisted_48 = { class: "text-left mt-2 font-bold text-slate-500" }
const _hoisted_49 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Animation = _resolveComponent("Animation")!
  const _component_Languages = _resolveComponent("Languages")!
  const _component_Message = _resolveComponent("Message")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_ctx.fireOn)
          ? (_openBlock(), _createBlock(_component_Animation, { key: 0 }))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_4, [
        (_ctx.currentToken == 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("button", {
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.mintNouns && _ctx.mintNouns(...args))),
                class: "bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
              }, _toDisplayString(_ctx.$t("getNoun")), 1)
            ]))
          : _createCommentVNode("", true),
        (_ctx.nfts[_ctx.currentToken] && !_ctx.fireOn)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createElementVNode("div", {
                class: _normalizeClass(["sm:w-1/2 w-full", _ctx.bgColor])
              }, [
                _createElementVNode("a", {
                  href: `${_ctx.openseaUrl}/assets/${_ctx.contractAddress}/${_ctx.currentToken}`,
                  target: "_blank"
                }, [
                  _createElementVNode("img", {
                    src: _ctx.nfts[_ctx.currentToken].data?.image,
                    class: "w-full"
                  }, null, 8, _hoisted_8)
                ], 8, _hoisted_7)
              ], 2),
              _createElementVNode("div", {
                class: _normalizeClass(["flex flex-1 flex-col sm:w-1/2 w-full pb-4 px-4", _ctx.bgColor])
              }, [
                _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.$t("acceptingBits")), 1),
                _createElementVNode("div", _hoisted_10, [
                  _createTextVNode(_toDisplayString(_ctx.nfts[_ctx.currentToken].data?.name), 1),
                  _hoisted_11
                ]),
                _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.nfts[_ctx.currentToken].data?.description), 1),
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.$t("currentPrice")), 1)
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("span", _hoisted_16, " 👉 Ξ " + _toDisplayString(_ctx.currentPrice), 1)
                ]),
                (_ctx.buying[_ctx.currentToken])
                  ? (_openBlock(), _createElementBlock("div", _hoisted_17, _hoisted_19))
                  : (_ctx.loading)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 1,
                        class: _normalizeClass(_ctx.bgColor)
                      }, "Processing...", 2))
                    : (_openBlock(), _createElementBlock("div", _hoisted_20, [
                        (_ctx.hasMetaMask)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.mintNouns && _ctx.mintNouns(...args))),
                              class: "bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded mt-6"
                            }, _toDisplayString(_ctx.$t("getNoun")), 1))
                          : (_openBlock(), _createElementBlock("div", _hoisted_21, _hoisted_23))
                      ]))
              ], 2)
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_24, [
              _createElementVNode("div", {
                class: _normalizeClass(["w-full h-60", _ctx.bgColor])
              }, _hoisted_26, 2)
            ])),
        _createElementVNode("div", _hoisted_27, [
          _createElementVNode("h1", null, _toDisplayString(_ctx.$t("aboutNounsLove")), 1)
        ]),
        _createElementVNode("div", _hoisted_28, [
          _createVNode(_component_Languages)
        ]),
        _createVNode(_component_Message),
        _createElementVNode("div", _hoisted_29, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.nftKeys, (tokenId, key) => {
            return (_openBlock(), _createElementBlock("div", {
              key: key,
              class: "mb-2"
            }, [
              (tokenId != _ctx.currentToken)
                ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                    _createElementVNode("div", _hoisted_31, [
                      _createVNode(_component_router_link, {
                        to: _ctx.localizedUrl('/noun/' + tokenId)
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("img", {
                            src: _ctx.nfts[tokenId].data?.image,
                            class: "w-1/2 m-auto"
                          }, null, 8, _hoisted_32)
                        ]),
                        _: 2
                      }, 1032, ["to"])
                    ]),
                    _createElementVNode("div", _hoisted_33, [
                      _createElementVNode("div", null, [
                        (_ctx.owners[tokenId])
                          ? (_openBlock(), _createElementBlock("span", _hoisted_34, " 💖You wons!! "))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_35, [
                        _createTextVNode(_toDisplayString(_ctx.nfts[tokenId].data?.name), 1),
                        _hoisted_36
                      ]),
                      _createElementVNode("div", _hoisted_37, _toDisplayString(_ctx.nfts[tokenId].data?.description), 1),
                      _createElementVNode("div", _hoisted_38, _toDisplayString(_ctx.$t("heldBy")), 1),
                      _createElementVNode("div", _hoisted_39, [
                        _createElementVNode("a", {
                          href: `${_ctx.openseaUrl}/${_ctx.nfts[tokenId]?.owner}`,
                          target: "_blank"
                        }, [
                          (_ctx.owners[tokenId])
                            ? (_openBlock(), _createElementBlock("span", _hoisted_41, [
                                _createTextVNode(_toDisplayString((_ctx.nfts[tokenId].owner || "").substr(0, 4)) + ".." + _toDisplayString((_ctx.nfts[tokenId].owner || "").substr(-4)) + " ", 1),
                                _hoisted_42
                              ]))
                            : (_openBlock(), _createElementBlock("span", _hoisted_43, [
                                _createTextVNode(_toDisplayString((_ctx.nfts[tokenId].owner || "").substr(0, 4)) + ".." + _toDisplayString((_ctx.nfts[tokenId].owner || "").substr(-4)), 1),
                                _hoisted_44
                              ]))
                        ], 8, _hoisted_40)
                      ]),
                      (tokenId % 10 !== 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_45, " Winning bid "))
                        : _createCommentVNode("", true),
                      (tokenId % 10 !== 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                            _createElementVNode("span", _hoisted_47, "💖 Ξ" + _toDisplayString(_ctx.nfts[tokenId].price), 1)
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_48, [
                        _createElementVNode("a", {
                          href: `${_ctx.openseaUrl}/assets/${_ctx.contractAddress}/${tokenId}`,
                          target: "_blank"
                        }, " OpenSea ", 8, _hoisted_49)
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]))
          }), 128))
        ])
      ]),
      _createElementVNode("div", {
        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.fire && _ctx.fire(...args))),
        class: "text-white"
      }, "nouns love!!")
    ])
  ]))
}